<script setup lang="ts">
  import Typography from '@/components/common/Typography.vue'
  import AppLayout from '@/components/layout/AppLayout.vue'
  import StandardLayout from '@/components/layout/Layout.vue'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
</script>

<template>
  <StandardLayout>
    <AppLayout>
      <div class="accesibility">
        <Typography
          variant="h2"
          component="h1"
        >
          {{ t('uuPage.title') }}
        </Typography>

        <Typography component="h2">
          {{ t('uuPage.welcome') }}
        </Typography>

        <Typography variant="h3">
          {{ t('uuPage.compliance.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.compliance.text1') }}
          <a
            href="https://www.uutilsynet.no/regelverk/offentlig-sektor/1584"
            target="_blank"
          >{{ t('uuPage.compliance.text2') }}
          </a>
          {{ t('uuPage.compliance.text3') }}
        </Typography>

        <Typography variant="h3">
          {{ t('uuPage.accessibilityFeatures.heading') }}
        </Typography>
        <Typography variant="h4">
          {{ t('uuPage.accessibilityFeatures.fontSize.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.fontSize.text') }}
        </Typography>
        <Typography variant="h4">
          {{ t('uuPage.accessibilityFeatures.listenToText.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.listenToText.text') }}
        </Typography>

        <Typography variant="h4">
          {{ t('uuPage.accessibilityFeatures.linksAndDocuments.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.linksAndDocuments.text') }}
        </Typography>

        <Typography variant="h4">
          {{ t('uuPage.accessibilityFeatures.keyboardNavigation.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.keyboardNavigation.text1') }}
        </Typography>
        <typography>
          {{ t('uuPage.accessibilityFeatures.keyboardNavigation.text2') }}
        </typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.keyboardNavigation.text3') }}
        </Typography>
        <typography>
          {{ t('uuPage.accessibilityFeatures.keyboardNavigation.text4') }}
        </typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.keyboardNavigation.text5') }}
        </Typography>

        <Typography variant="h4">
          {{ t('uuPage.accessibilityFeatures.altText.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.altText.text') }}
        </Typography>

        <Typography variant="h4">
          {{ t('uuPage.accessibilityFeatures.videoCaptioning.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.videoCaptioning.text') }}
        </Typography>
        <Typography variant="h4">
          {{ t('uuPage.accessibilityFeatures.supportedDevices.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.supportedDevices.text') }}
          <ul>
            <li>Chrome</li>
            <li>Edge</li>
            <li>Safari</li>
          </ul>
        </Typography>

        <Typography variant="h4">
          {{ t('uuPage.accessibilityFeatures.feedback.heading') }}
        </Typography>
        <Typography>
          {{ t('uuPage.accessibilityFeatures.feedback.text1') }}
          <a href="https://skole.aschehoug.no/kundeservice">
            {{ t('uuPage.accessibilityFeatures.feedback.text2') }}
          </a>
        </Typography>
      </div>
    </AppLayout>
  </StandardLayout>
</template>

<style scoped lang="scss">
  .accesibility {
    max-width: 800px;
    padding-top: 50px;
    margin: 0 auto;

    h4, h3 {
      margin-top: 50px;
    }
  }

</style>
